import React, { useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  TextField,
  InputAdornment,
  ListSubheader,
  Box,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { Spaces } from "../../assets/Variables/SpaceVariables.js";
import Colors from "../../assets/Variables/ColorsVariables.js";
import * as TextVariables from "../../assets/Variables/TextVariables";
import TableToolTip from "../../components/ToolTips/TableToolTip";

const TitledMultiSelector = ({
  title,
  value = [],
  handleChange,
  options,
  tooltext = "",
  fullWidth = false,
  width = "172px",
  height = "33px",
  disabled = false,
}) => {
  const selectStyle = {
    borderRadius: "8px",
    height,
    width: fullWidth ? "100%" : width,
    fontFamily: TextVariables.Caption_1,
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const stopImmediatePropagation = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div style={fullWidth ? { width: "100%" } : undefined}>
      <Box
        sx={{
          marginRight: "10px",
          marginBottom: "5px",
          display: "flex",
          flexDirection: "row",
          gap: Spaces.Size_1,
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontFamily: TextVariables.Caption_1 }}>
          {title}
        </Typography>
        {tooltext !== "" && (
          <TableToolTip title={tooltext}>
            <Box>
              <span
                style={{ fontSize: Spaces.Size_3 }}
                className="material-symbols-outlined"
              >
                help
              </span>
            </Box>
          </TableToolTip>
        )}
      </Box>

      <FormControl
        variant="outlined"
        fullWidth={fullWidth}
        style={fullWidth ? undefined : { marginRight: "15px" }}
      >
        <Select
          multiple
          disabled={disabled}
          value={Array.isArray(value) ? value : []}
          onChange={(e) => handleChange(e.target.value)}
          sx={{
            ...selectStyle,
            fontFamily: TextVariables.Caption_1,
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                fontFamily: TextVariables.Caption_1,
              },
            },
          }}
          renderValue={(selected) =>
            options
              .filter((option) => selected.includes(option.value))
              .map((option) => option.label)
              .join(", ")
          }
        >
          <ListSubheader sx={{ display: "flex", padding: Spaces.Size_3 }}>
            <TextField
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: `1px solid ${Colors.Secondary_400}`,
                borderRadius: Spaces.Size_2,
                fontFamily: TextVariables.Caption_1,
                padding: "0px",
                "& .MuiInputBase-input": {
                  fontFamily: TextVariables.Caption_1,
                  padding: Spaces.Size_4,
                },
              }}
              onClickCapture={stopImmediatePropagation}
              onKeyDown={(e) => e.stopPropagation()}
              fullWidth
              placeholder="Search"
              onChange={handleSearchChange}
              value={searchTerm}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <span className="material-symbols-outlined">search</span>
                  </InputAdornment>
                ),
                sx: {
                  "& .MuiInputBase-input::placeholder": {
                    fontFamily: TextVariables.Caption_1,
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                },
                autoComplete: "off",
              }}
            />
          </ListSubheader>

          {filteredOptions.map((option, index) => (
            <MenuItem
              key={index}
              value={option.value}
              sx={{ fontFamily: TextVariables.Caption_1 }}
            >
              <Checkbox
                checked={value.includes(option.value)}
                sx={{ padding: "0 8px" }}
              />
              <ListItemText
                primary={option.label}
                primaryTypographyProps={{ fontFamily: TextVariables.Caption_1 }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TitledMultiSelector;